import { DownloadIcon } from "../../shared/Icons";
import { themeAtom } from "../../shared/atoms";
import { toastError, toastSuccess } from "../../shared/components/ToastContainer";
import { downloadBQ } from "../services/download-bq.service";
import { useAtomValue } from "jotai";
import { useParams } from "react-router";
import { twMerge } from "tailwind-merge";

interface DownloadBQButtonProps {
  loadingToggle: (loading: boolean) => void;
}

const DownloadBQButton = ({ loadingToggle }: DownloadBQButtonProps) => {
  const theme = useAtomValue(themeAtom);

  const { imoNumber, vesselName } = useParams();

  const handleDownload = async () => {
    try {
      loadingToggle(true);
      await downloadBQ({ imoNumber, vesselName });
    } catch (error) {
      toastError("Download failed");
      console.error("Download failed:", error);
    } finally {
      loadingToggle(false);
      toastSuccess("Download successful");
    }
  };

  return (
    <button
      onClick={handleDownload}
      className={twMerge(
        "focus:ring-green-200 flex h-[40px] flex-row items-center rounded border py-2 pl-4 pr-5 text-[14px] text-sm focus:outline-none",
        theme.headerComponent.tailwind.buttonBorder,
        theme.headerComponent.tailwind.backButtonBg,
        theme.myVesselsTable.tailwind.linkText,
        theme.headerComponent.tailwind.buttonHoverBg,
        theme.headerComponent.tailwind.buttonHoverText,
      )}
    >
      <div>
        <DownloadIcon />
      </div>
      <div className="ml-3">Download</div>
    </button>
  );
};

export default DownloadBQButton;
